import React, { createContext, useState, useEffect, useContext } from 'react';
import {
  getCustomIndicators,
  createCustomIndicator,
  updateCustomIndicator,
  deleteCustomIndicator,
} from '../services/api';

const CustomIndicatorContext = createContext();

export const CustomIndicatorProvider = ({ children }) => {
  const [customIndicators, setCustomIndicators] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadCustomIndicators = async () => {
    try {
      const response = await getCustomIndicators();
      setCustomIndicators(response.data);
    } catch (error) {
      console.error('Failed to load custom indicators:', error);
      // Don't throw error - just log it. User might not be authenticated yet.
      setCustomIndicators([]);
    } finally {
      setLoading(false);
    }
  };

  const addCustomIndicator = async (data) => {
    const response = await createCustomIndicator(data);
    setCustomIndicators([response.data, ...customIndicators]);
    return response.data;
  };

  const updateIndicator = async (id, data) => {
    const response = await updateCustomIndicator(id, data);
    setCustomIndicators(
      customIndicators.map((ci) => (ci.id === id ? response.data : ci))
    );
    return response.data;
  };

  const deleteIndicator = async (id) => {
    await deleteCustomIndicator(id);
    setCustomIndicators(customIndicators.filter((ci) => ci.id !== id));
  };

  useEffect(() => {
    // Only load custom indicators if we have a token (user is logged in)
    const token = localStorage.getItem('token');
    if (token) {
      loadCustomIndicators();
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <CustomIndicatorContext.Provider
      value={{
        customIndicators,
        loading,
        loadCustomIndicators,
        addCustomIndicator,
        updateIndicator,
        deleteIndicator,
      }}
    >
      {children}
    </CustomIndicatorContext.Provider>
  );
};

export const useCustomIndicators = () => {
  const context = useContext(CustomIndicatorContext);
  if (!context) {
    throw new Error(
      'useCustomIndicators must be used within CustomIndicatorProvider'
    );
  }
  return context;
};
